import {
    Insurance,
} from '../src/insurance-data';

import {
    init,
    select,
    SelectList,
} from 'one-state-core';

import {
    SET,
    RESET,
    SELECT,
} from './types';

import {
    Actions,
} from './actions';

export const insurancedetails = (
    context: any,
    initial?: SelectList<Insurance>,
) => {
    const initValue = initial || {
        values: [],
    };

    return (
        state: SelectList<Insurance>,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state || initValue;
        switch (type) {
            case SET:
                updated = init<Insurance>(
                    updated,
                    payload,
                );
                break;
                
            case RESET:
                updated = initValue;
                break;

            case SELECT:
                updated = select<Insurance>(
                    updated,
                    (insurance) => (
                        insurance.groupnumber === payload
                    ),
                );
                break;
        }
        return updated;
    }
};
